import { useState, useEffect } from 'react';
import { settingsService, AppSettings } from '../services/settingsService';

export const useSettings = () => {
  const [settings, setSettings] = useState<AppSettings | null>(settingsService.getAllSettings());
  const [loading, setLoading] = useState<boolean>(!settingsService.isLoaded());
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = settingsService.subscribe((newSettings) => {
      setSettings(newSettings);
      setLoading(false);
    });

    // Initialize settings if not already loaded
    if (!settingsService.isLoaded()) {
      setLoading(true);
      settingsService.initializeSettings().catch((err) => {
        setError(err.message);
        setLoading(false);
      });
    }

    return unsubscribe;
  }, []);

  // Helper function to get specific setting with fallback
  const getSetting = <K extends keyof AppSettings>(key: K, fallback?: AppSettings[K]): AppSettings[K] => {
    if (settings && settings[key] !== null && settings[key] !== undefined) {
      return settings[key];
    }
    return fallback !== undefined ? fallback : settingsService.getSetting(key);
  };

  return {
    settings,
    loading,
    error,
    getSetting,
    refreshSettings: () => settingsService.initializeSettings(),
  };
};